/**
 * @generated SignedSource<<de2377a2b62363ca22fd40e607a1d753>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutTitle_checkout$data = {
  readonly title: string | null | undefined;
  readonly " $fragmentType": "PaymentCheckoutTitle_checkout";
};
export type PaymentCheckoutTitle_checkout$key = {
  readonly " $data"?: PaymentCheckoutTitle_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutTitle_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutTitle_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "bf3fceae0bf5116833b123b0a4ff513a";

export default node;
